import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=0422ad5e"
import script from "./Appearance.vue?vue&type=script&lang=js"
export * from "./Appearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports